import { render } from "./EventDetails.vue?vue&type=template&id=1d0e2db6&ts=true"
import script from "./EventDetails.vue?vue&type=script&lang=ts"
export * from "./EventDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__